// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","title":"Header_title__3SH2Q","githubButton":"Header_githubButton__1QU63","githubIcon":"Header_githubIcon__3WX53"};